import { Component, OnInit } from "@angular/core";
import {
  AuthenticationGuard,
  MsAdalAngular6Service,
} from "microsoft-adal-angular6";
import { UserService } from "./shared/service/user.service";
import { SpinnerService } from "./shared/service/spinner-service";
import {
  Router,
  NavigationStart,
  NavigationEnd,
  ActivatedRoute,
} from "@angular/router";
import { ApplicationPageDetails } from "./shared/models/application-page-details.interface";
import { Observable } from "rxjs";
import { filter } from "rxjs/Operators";
import { AppConfig } from "./app.config";
import { ComponentIdentificationService } from "./shared/service/component-identification.service";
import { IdleTimeoutService } from "./shared/service/idle-timeout.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "WinPR";
  year = new Date().getFullYear();
  userName: string = "";
  isAuthenticate: boolean = false;
  pageDetails: any;
  currentUrlPath: any;
  isOnboarding: boolean = false;
  winPayURL: string;
  EmpCode: number;
  listOfMenu: any;
  mainHeaderSelectedTab: string = "Master";
  mainHeaderUrl: string = "/hremployeelist";
  offboardingId: number;

  menuOrder = [
    "Master",
    "Onboarding",
    "Offboarding",
    "MonthClose",
    "Resumes",
    "MyProfile",
    "Insurance",
    "Awards",
    "Holidays",
    "Permissions",
  ];
  constructor(
    private adalSvc: MsAdalAngular6Service,
    public _userService: UserService,
    public spinnerService: SpinnerService,
    private router: Router,
    private config: AppConfig,
    private chngCom_Svc: ComponentIdentificationService,
    private route: ActivatedRoute,
    private idleTimeoutService: IdleTimeoutService
  ) {}

  ngOnInit() {
    //this.isAuthenticate = this.adalSvc.isAuthenticated;
    //if (this.adalSvc.isAuthenticated) {
    //  this.userName = this.adalSvc.LoggedInUserName;
    //  if (this._userService.getEmpCode() == null || this._userService.getEmpCode() == 0) {
    //    this._userService.setUserDetails();
    //  }
    //} else {
    //  this.adalSvc.login();
    //}

    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart, NavigationEnd))
      .subscribe((event: any) => {
        const urlDelimitators = new RegExp(/[?//,;&:#$+=]/);
        this.currentUrlPath = event.url.slice(1).split(urlDelimitators)[0];
        const id = event.url.slice(1).split(urlDelimitators)[1];
        this.offboardingId = id;
        if (
          this.currentUrlPath == "activation" ||
          this.currentUrlPath == "onboarding" ||
          this.currentUrlPath == "submission"
        ) {
          this.isOnboarding = true;
        } else {
          this.isAuthenticate = this.adalSvc.isAuthenticated;
          if (this.adalSvc.isAuthenticated) {
            this.userName = this.adalSvc.LoggedInUserName;
            this.winPayURL = this.config.winPayURL;
            this._userService.setUserDetails(this.offboardingId);
            setTimeout(() => {
              let entireList = this._userService.applicationMenu() || [];

              entireList = entireList
                .sort((a, b) => {
                  return (
                    this.menuOrder.indexOf(a.Menu) -
                    this.menuOrder.indexOf(b.Menu)
                  );
                })
                .map((menu) => {
                  menu.SubMenu = menu.SubMenu.filter(
                    (submenu) =>
                      ![
                        "Compensation & Benefits",
                        "Insurance-HR",
                        "Set-Insurance-Options",
                      ].includes(submenu.Name)
                  );
                  return menu;
                });

              this.listOfMenu = entireList.filter((menu) =>
                ["Insurance", "MyProfile"].includes(menu.Menu)
              );
            }, 1000);
          } else {
            this.adalSvc.login();
          }
        }
      });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (sessionStorage.getItem("mainHeaderSelectedTab") == null) {
          sessionStorage.setItem("mainHeaderSelectedTab", "Master");
          sessionStorage.setItem(
            "mainHeaderUrl",
            this.listOfMenu[0].SubMenu[0].URL
          );
          this.mainHeaderSelectedTab = "Master";
          this.mainHeaderUrl = this.listOfMenu[0].SubMenu[0].URL;
        } else {
          var tab = sessionStorage.getItem("mainHeaderUrl");
          if (this.router.url.split("/")[1] === "Insurance") {
            sessionStorage.setItem("mainHeaderSelectedTab", "Insurance");
            sessionStorage.setItem("mainHeaderUrl", `/EmpnsuranceList`);
            this.mainHeaderUrl = "/EmpnsuranceList";
          } else if (tab == this.router.url) {
            this.mainHeaderSelectedTab = sessionStorage.getItem(
              "mainHeaderSelectedTab"
            );
            this.mainHeaderUrl = this.router.url;
          } else {
            if (this.router.url.split("/")[1] === "hremployeedetails") {
              sessionStorage.setItem("mainHeaderSelectedTab", "Master");
              sessionStorage.setItem("mainHeaderUrl", "/hremployeelist");
              this.mainHeaderUrl = "/hremployeelist";
            } else if (this.router.url.split("/")[1] === "onboardingdetails") {
              sessionStorage.setItem("mainHeaderSelectedTab", "Onboarding");
              sessionStorage.setItem("mainHeaderUrl", "/employeelist");
              this.mainHeaderUrl = "/employeelist";
            } else if (this.router.url.split("/")[1] === "addpermissions") {
              sessionStorage.setItem("mainHeaderSelectedTab", "Permissions");
              sessionStorage.setItem("mainHeaderUrl", "/Permissions");
              this.mainHeaderUrl = "/Permissions";
            } else if (
              this.router.url.split("/")[1] === "Offboardinglist" ||
              this.router.url.split("/")[1] === "offboardingfeedback" ||
              this.router.url.split("/")[1] === "offboardingdetails"
            ) {
              sessionStorage.setItem(
                "mainHeaderSelectedTab",
                "Offboardinglist"
              );
              sessionStorage.setItem(
                "mainHeaderUrl",
                "/Offboardinglist/tabIndex/0"
              );
              this.mainHeaderUrl = "/Offboardinglist/tabIndex/0";
            } else if (this.router.url.split("/")[1] === "holidaylistdetails") {
              sessionStorage.setItem("mainHeaderSelectedTab", "holidaylist");
              sessionStorage.setItem("mainHeaderUrl", "/holidaylist");
              this.mainHeaderUrl = "/holidaylist";
            } else if (this.router.url.split("/")[1] === "Insurance") {
              sessionStorage.setItem("mainHeaderSelectedTab", "Insurance");
              sessionStorage.setItem("mainHeaderUrl", "/Insurance");
              this.mainHeaderUrl = "/Insurance";
            } else {
              sessionStorage.setItem("mainHeaderUrl", this.router.url);
              sessionStorage.setItem("mainHeaderSelectedTab", "Master");
              this.mainHeaderUrl = this.router.url;
            }
            const mainListMenu = this.listOfMenu || [];
            this.mainHeaderSelectedTab =
              mainListMenu.find((menu) => menu.URL == tab) != null
                ? this.listOfMenu.find((menu) => menu.URL == tab).Menu
                : sessionStorage.getItem("mainHeaderSelectedTab");
          }
        }
      });
  }

  getSomeClass(idx, mainHeaderUrl) {
    let finalVal =
      this.listOfMenu &&
      this.listOfMenu[idx] &&
      this.listOfMenu[idx].SubMenu.find((menu) => menu.URL == mainHeaderUrl);
    if (finalVal) {
      return finalVal.URL.split("/")[1];
    }
  }

  selected(menu: any) {
    this.router.navigate([menu.URL]);
  }

  singout() {
    this._userService.clearStorage();
    this._userService.allClearStorage();
    this.adalSvc.logout();
  }

  GetEmployeebyId() {
    this.EmpCode = this._userService.getEmpCode();
    this.chngCom_Svc.changeComponentName("app-root");
    this.router.navigateByUrl("/myprofile/" + this.EmpCode);
  }

  toggleBtnColor(item) {
    const { Menu } = item;
    this.mainHeaderSelectedTab = Menu;
    this.mainHeaderUrl = item.URL;
    sessionStorage.setItem("mainHeaderSelectedTab", Menu);
    sessionStorage.setItem("mainHeaderUrl", item.URL);
  }
}
